"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.richContentKeys = exports.RichContentAttributes = void 0;
var RichContentAttributes;
(function (RichContentAttributes) {
    RichContentAttributes["semanticContent"] = "semanticContent";
    RichContentAttributes["fragments"] = "fragments";
    RichContentAttributes["text"] = "text";
    RichContentAttributes["money"] = "money";
    RichContentAttributes["paragraph"] = "paragraph";
    RichContentAttributes["link"] = "link";
    RichContentAttributes["dateTime"] = "dateTime";
    RichContentAttributes["headingContent"] = "headingContent";
    RichContentAttributes["inlinePopover"] = "inlinePopover";
    RichContentAttributes["list"] = "list";
    RichContentAttributes["media"] = "media";
    RichContentAttributes["popover"] = "popover";
})(RichContentAttributes = exports.RichContentAttributes || (exports.RichContentAttributes = {}));
exports.richContentKeys = [
    'text',
    'fragments',
    'headingContent',
    'link',
    'list',
    'media',
    'paragraph',
    'semanticContent',
    'money'
];
